import HistoryDetail from './HistoryDetail';

export {HistoryDetail};
